var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24144 3.26213L1.756 14.1975C1.62229 14.4314 1.55154 14.6965 1.55079 14.9666C1.55004 15.2367 1.61932 15.5023 1.75173 15.7369C1.88415 15.9715 2.07509 16.167 2.30555 16.304C2.53601 16.441 2.79796 16.5146 3.06534 16.5176H16.0362C16.3036 16.5146 16.5656 16.441 16.796 16.304C17.0265 16.167 17.2174 15.9715 17.3498 15.7369C17.4822 15.5023 17.5515 15.2367 17.5508 14.9666C17.55 14.6965 17.4793 14.4314 17.3456 14.1975L10.8601 3.26213C10.7236 3.03484 10.5314 2.84693 10.3021 2.71651C10.0727 2.58609 9.81398 2.51758 9.55078 2.51758C9.28758 2.51758 9.02883 2.58609 8.79948 2.71651C8.57014 2.84693 8.37794 3.03484 8.24144 3.26213Z",
    stroke: "#F16060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.09766V10.431",
    stroke: "#F16060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 13.332H9.635",
    stroke: "#F16060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.4f0d8378f3b81b89efc00d7c5da9d049.svg";
export { ForwardRef as ReactComponent };